export function selectListData(state: any, reduxKey: string) {
	return state.listData?.[reduxKey];
}
